import { ActionCreator, getType } from 'typesafe-actions';
import { Action } from 'redux';

type Subscriber = {
    resolve: (action: Action) => void;
    actionCreator: ActionCreator<any>;
    matches?: (action: Action) => boolean | null;
}

export class ActionsAwaiter {
    private subscribers: Subscriber[] = [];

    public waitFor<T extends ActionCreator<any>>(
        actionCreator: T,
        matches: (action: ReturnType<T>) => boolean = null,
    ): Promise<ReturnType<T>> {
        let resolve: (action: ReturnType<T>) => void;

        const promise = new Promise<ReturnType<T>>((r) => {
            resolve = r;
        });

        this.subscribers.push({
            resolve,
            matches,
            actionCreator,
        });

        return promise;
    }

    public onAction(action: Action): void {
        this.subscribers = this.subscribers.filter((subscriber) => {
            if (
                getType(subscriber.actionCreator) === action.type &&
                (!subscriber.matches || subscriber.matches(action))
            ) {
                subscriber.resolve(action);
                return false;
            }

            return true;
        });
    }
}
